import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_repeat_click = _resolveDirective("repeat-click")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'el-input-number',
      _ctx.inputNumberSize ? 'el-input-number--' + _ctx.inputNumberSize : '',
      { 'is-disabled': _ctx.inputNumberDisabled },
      { 'is-without-controls': !_ctx.controls },
      { 'is-controls-right': _ctx.controlsAtRight },
    ]),
    onDragstart: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
  }, [
    (_ctx.controls)
      ? _withDirectives((_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["el-input-number__decrease", { 'is-disabled': _ctx.minDisabled }]),
          role: "button",
          onKeydown: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.decrease && _ctx.decrease(...args)), ["enter"]))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(`el-icon-${_ctx.controlsAtRight ? 'arrow-down' : 'minus'}`)
          }, null, 2)
        ], 34)), [
          [_directive_repeat_click, _ctx.decrease]
        ])
      : _createCommentVNode("", true),
    (_ctx.controls)
      ? _withDirectives((_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["el-input-number__increase", { 'is-disabled': _ctx.maxDisabled }]),
          role: "button",
          onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.increase && _ctx.increase(...args)), ["enter"]))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(`el-icon-${_ctx.controlsAtRight ? 'arrow-up' : 'plus'}`)
          }, null, 2)
        ], 34)), [
          [_directive_repeat_click, _ctx.increase]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_el_input, {
      ref: "input",
      "model-value": _ctx.displayValue,
      placeholder: _ctx.placeholder,
      disabled: _ctx.inputNumberDisabled,
      size: _ctx.inputNumberSize,
      max: _ctx.max,
      min: _ctx.min,
      name: _ctx.name,
      label: _ctx.label,
      onKeydown: [
        _withKeys(_withModifiers(_ctx.increase, ["prevent"]), ["up"]),
        _withKeys(_withModifiers(_ctx.decrease, ["prevent"]), ["down"])
      ],
      onBlur: _cache[2] || (_cache[2] = event => _ctx.$emit('blur', event)),
      onFocus: _cache[3] || (_cache[3] = event => _ctx.$emit('focus', event)),
      onInput: _ctx.handleInput,
      onChange: _ctx.handleInputChange
    }, null, 8, ["model-value", "placeholder", "disabled", "size", "max", "min", "name", "label", "onKeydown", "onInput", "onChange"])
  ], 34))
}